import { Component } from '@angular/core';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'safe-password-security-info',
	template: require('./safe-password-security-info.component.html'),
	host: { class: 'flex-column ' },
})
export class SafePasswordSecurityInfoComponent {
	public isRebrading = AppSettings.isRebrading;
}
